import { Injectable } from '@angular/core';
import { GetAllResponse } from '../model/restful-api.model';
import { environment } from 'src/environments/environment';
import { API_URL } from '../enums/api-enums';
import { Observable } from 'rxjs';
import { RequestHelper, UtilitiesService } from 'src/app/core/services/utilities.service';
import { GeTagRequest } from '../model/ge-tag-request-form.module';
import { TicketRequest } from '../model/ticket-access-request.model';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})

export class GeTagRequestFormService {

  private requestHelper: RequestHelper;
  constructor(private utilities: UtilitiesService,
    private http: HttpClient
  ) { }

  createRequestFormData(body): Observable<GetAllResponse<GeTagRequest>> {
    const url = environment.portalURL + API_URL.GE_TAG_REQUEST_FORM;
    return this.utilities.req.httpPost<GetAllResponse<GeTagRequest>>(url, body);
  }

  uploadAttachment(file: File) {
    const formData = new FormData();
    formData.append("file", file, file.name);
    const url = environment.portalURL + API_URL.GE_TAG_REQUEST_FORM_FILE_UPLOAD;
    return this.utilities.req.httpPost<GetAllResponse<any>>(url, formData);
  }

  getAllRecords(): Observable<GetAllResponse<any>> {
    const url = environment.portalURL + API_URL.GE_TAG_REQUEST_RECORDS;
    return this.utilities.req.httpGet<GetAllResponse<any>>(url);
  }

  updateRecord(body): Observable<GetAllResponse<any>> {
    const url = environment.portalURL + API_URL.GE_TAG_REQUEST_UPDATE_RECORD;
    return this.utilities.req.httpPost<GetAllResponse<any>>(url, body);
  }

  getRequestAccessList(): Observable<GetAllResponse<TicketRequest>> {
    const url = environment.portalURL + API_URL.GE_TAG_REQUEST_URL;
    return this.utilities.req.httpGet<GetAllResponse<TicketRequest>>(url);
  }

  getReturnedList(): Observable<GetAllResponse<TicketRequest>> {
    const url = environment.portalURL + API_URL.GE_TAG_RETURN_URL;
    return this.utilities.req.httpGet<GetAllResponse<TicketRequest>>(url);
  }

  getRecordDetails(recordId): Observable<GetAllResponse<any>> {
    const url = `${environment.portalURL}${API_URL.GE_TAG_GET_REQUEST}/${recordId}`;
    return this.utilities.req.httpGet<GetAllResponse<any>>(url);
  }

}
